import { render } from "./building-info.vue?vue&type=template&id=2ddd6f63&scoped=true"
import script from "./building-info.vue?vue&type=script&lang=js"
export * from "./building-info.vue?vue&type=script&lang=js"

import "./building-info.vue?vue&type=style&index=0&id=2ddd6f63&lang=scss&scoped=true"

import exportComponent from "/www/publicHouse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ddd6f63"]])

export default __exports__